import React, { useCallback, useEffect, useState } from "react";
import baseUrl from "../../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import { Socket, connect } from "socket.io-client";
import socketauth from "../../../../../api/socket";

const socket: Socket = connect(`${process.env.REACT_APP_WS}`, socketauth);

const statusStyles: Record<string, string> = {
  ongoing: "bg-lime-100 text-lime-700 border-lime-300",
  inqueue: "bg-sky-100 text-sky-700 border-sky-300",
  canceled: "bg-red-100 text-red-700 border-red-300",
  completed: "bg-emerald-100 text-emerald-700 border-emerald-300",
  appointment: "bg-orange-100 text-orange-700 border-orange-300",
  reschudle: "bg-cyan-100 text-cyan-700 border-cyan-300",
  noshow: "bg-slate-100 text-slate-700 border-slate-300",
  default: "bg-white text-slate-600 border-slate-200",
};

function AppointmentTr({ item, appointmStatus }: any) {
  const [select, setselect] = useState(item?.status);
  const navigate = useNavigate();

  useEffect(() => {
    setselect(item?.status);
  }, [item]);

  const handleChange = (e: any) => {
    setselect(e.target.value);
    socket.emit("allAppointmentStatus", {
      appointmentid: item?._id,
      status: e.target.value,
    });
    baseUrl
      .patch(
        "/appointment/statusAppointmentById",
        {},
        {
          headers: { appointmentid: item?._id, status: e.target.value },
        }
      )
      .then(() => appointmStatus())
      .catch((error) => console.log(error));
  };

  const handleTreatmentClick = useCallback(
    (id: string, e: React.MouseEvent) => {
      e.stopPropagation();
      baseUrl
        .post("treatment/create-treatment", { patientId: id })
        .then((response) => {
          navigate(
            `/client/treatment-diagnose/add-treatment/diagnose/${response.data.data._id}`
          );
        })
        .catch((error) => console.error(error));
    },
    [navigate]
  );

  const handleClickGoViewPatient = useCallback(
    (id: string) => navigate(`/client/patients/patientone/general-detail/${id}`),
    [navigate]
  );

  return (
    <tr className="hover:bg-slate-50/50 transition-colors group">
      <td className="px-6 py-3 text-sm font-semibold text-slate-900">
        {item?.patientId?.fullName ? item?.patientId?.fullName : item?.bookPatientId?.fullName || "N/A"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm text-slate-600">
        {item?.date?.split("T")[0]}
      </td>
      <td className="px-6 py-3">
        <span className="px-2.5 py-1 bg-primary/10 text-primary rounded-md text-xs font-medium">
          {item?.startTime} - {item?.endTime}
        </span>
      </td>
      <td className="px-6 py-3">
        <select
          onChange={handleChange}
          value={select}
          className={`px-3 py-1.5 rounded-lg text-sm font-medium border cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/20 transition-colors ${
            statusStyles[select] || statusStyles.default
          }`}
        >
          <option value="">Select</option>
          <option value="appointment">Upcoming</option>
          <option value="completed">Completed</option>
          <option value="canceled">Canceled</option>
          <option value="inqueue">In Queue</option>
          <option value="ongoing">Ongoing</option>
          <option value="noshow">No Show</option>
        </select>
      </td>
      <td className="px-6 py-3 text-sm text-slate-700">
        {item?.purposeId?.purposeName || item?.bookTreatmentId?.name || "N/A"}
      </td>
      <td className="px-6 py-3">
        <span className={`px-2.5 py-1 rounded-md text-xs font-medium capitalize ${
          item?.type === "online" ? "bg-primary/10 text-primary" : "bg-emerald-100 text-emerald-700"
        }`}>
          {item?.type || "N/A"}
        </span>
      </td>
      <td className="px-6 py-3">
        <div className="flex gap-2 justify-center">
          {item?.patientId?.fullName ? (
            <>
              <button
                onClick={() => handleClickGoViewPatient(item?.patientId?._id)}
                className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center hover:bg-indigo-100 active:bg-indigo-200 transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 opacity-0 group-hover:opacity-100"
                title="View Patient"
                aria-label="View Patient"
              >
                <RemoveRedEyeIcon sx={{ fontSize: 18 }} />
              </button>
              <button
                onClick={(e: any) => handleTreatmentClick(item?.patientId?._id, e)}
                className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center hover:bg-emerald-100 active:bg-emerald-200 transition-all focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1 opacity-0 group-hover:opacity-100"
                title="Add Treatment"
                aria-label="Add Treatment"
              >
                <MedicalInformationIcon sx={{ fontSize: 18 }} />
              </button>
            </>
          ) : (
            <span className="text-xs text-slate-400 italic">Patient not added</span>
          )}
        </div>
      </td>
    </tr>
  );
}

export default AppointmentTr;
